import type { NextPage } from 'next'

import FarmerHelpline from '@/components/farmerHelpline'
import LayoutWithNavigation from '@/components/layoutWithNavigation'

export async function getStaticProps() {
  return {
    props: {
      title: 'Farmers Helpline & Farmers Support | 1800 1036 110 | DeHaat',
      description:
        'Farmers Helpline and Farmers Support. Call on DeHaat Toll Free Kisan Helpline Number 1800 1036 110 and get free guidance on any agricultural aspects.',
    },
  }
}

const AdvisoryFarmersHelpline: NextPage = () => (
  <LayoutWithNavigation>
    <FarmerHelpline />
  </LayoutWithNavigation>
)

export default AdvisoryFarmersHelpline
